<template>
  <div
    class="template-padding table-responsive"
    style="height: 80vh"
  >
    <ul
      class="nav nav-tabs"
      id="list-tab"
      role="tablist"
    >
      <li
        class="nav-item"
      >
        <button
          role="tab"
          data-toggle="list"
          id="listSummary"
          class="nav-link font-weight-bold active"
          href="#tabSummary"
        >
          Summary
        </button>
      </li>
      <li
        class="nav-item mb-1"
        v-for="course in trainingEndorsementData"
        :key="course.id"
        :title="course.name"
      >
        <button
          role="tab"
          data-toggle="list"
          :id="'list' + course.id"
          class="nav-link font-weight-bold"
          :href="'#tab' + course.id"
        >
          {{ course.code }}
        </button>
      </li>
    </ul>

    <div
      class="tab-content"
      id="nav-tabContent1"
    >
      <div
        class="tab-pane fade show active"
        role="tabpanel"
        aria-labelledby="#listSummary"
        id="tabSummary"
      >
        <div class="row">
          <div class="col">
            <h5 class="font-weight-bold text-center m-2">
              KRBS-ROHQ TRAINING LIST
            </h5>
          </div>
        </div>
        <div class="row">


          <div class="col col-auto my-auto">
            <div class="form-group form-row my-auto">
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="dateFrom"
              >From: </label>
              <div class="col col-sm-8">
                <input
                  type="date"
                  id="dateFrom"
                  class="form-control form-control-xs"
                  v-model="params.from"
                >
              </div>
            </div>
          </div>

          <div class="col col-auto my-auto">
            <div class="form-group form-row my-auto">
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="dateTo"
              >To: </label>
              <div class="col col-sm-8">
                <input
                  type="date"
                  id="dateTo"
                  class="form-control form-control-xs"
                  v-model="params.to"
                >
              </div>
            </div>
          </div>

          <div class="col col-auto my-auto">
            <div class="form-group form-row my-auto">
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="endorsedBy"
              >Endorsed By: </label>
              <div class="col col-sm-8">
                <select
                  class="form-control form-control-sm"
                  name="endorsed_by"
                  id="endorsed_by"
                  v-model="params.user_id"
                >
                  <option :value="null">
                    --- SELECT ENDORSER ---
                  </option>
                  <option
                    :key="trainingAssistant.id"
                    :value="trainingAssistant.id"
                    v-for="trainingAssistant in trainingAssistants"
                  >
                    {{ trainingAssistant.name }} {{ trainingAssistant.last_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col col-auto my-auto">
            <button
              class="input-group-text input-group-append rounded-right"
              @click="getTrainingEndorsementData(params)"
            >
              <i class="fas fa-search" />
            </button>
          </div>

          <div class="col col-sm-2 my-auto text-right">
            <button
              class="btn btn-sm btn-outline-primary font-weight-bold"
              @click="generateKrbsTrainingEndorsementReport(params)"
            >
              <span class="fas fa-download" />
              Generate Report
            </button>
          </div>
        </div>
        <table class="table table-hover table-bordered table-padding-1 sticky-header">
          <thead>
            <tr class="table-header text-center">
              <th class="col-index">
                #
              </th>
              <th>TRAINING COURSE</th>
              <th>SCHEDULED CREWS</th>
            </tr>
          </thead>

          <tbody>
            <tr
              class="header-button"
              @click="switchTab(course.id)"
              v-for="(course, index) in trainingEndorsementData"
              :key="course.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ course.name }}</td>
              <td class="text-center">
                {{ course.scheduledCrews.length }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-for="course in trainingEndorsementData"
        :key="course.id"
        class="tab-pane fade show"
        role="tabpanel"
        :aria-labelledby="'#list' + course.id"
        :id="'tab' + course.id"
      >
        <h5 class="font-weight-bold text-center m-2">
          {{ course.name }}
        </h5>

        <table class="table table-hover table-bordered table-padding-1 sticky-header">
          <thead>
            <tr class="table-header text-center">
              <th class="col-index">
                #
              </th>
              <th>COMPLETE NAME</th>
              <th>RANK</th>
              <th>ASSIGNED VESSEL</th>
              <th>ETD</th>
              <th>AGENT</th>
              <th>BIRTH DATE</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(crew, index) in course.scheduledCrews"
              :key="crew.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ crew.crewName }}</td>
              <td>{{ crew.rankAlias }}</td>
              <td>{{ crew.vessel }}</td>
              <td>{{ crew.etd | moment('DD MMM YYYY') }}</td>
              <td>VRS</td>
              <td> {{ crew.birthdate | moment('DD MMM YYYY') }} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "TrainingEndorsement",

        data() {
            return {
                params: {
                    from: '',
                    to: '',
                    user_id:null,
                }
            }
        },

        methods: {
            ...mapActions([ 'getTrainingEndorsementData', 'generateKrbsTrainingEndorsementReport','getTrainingAssistants']),
            async initializeData() {
                // let date = new Date();
                // this.params.from = new Date(date.getFullYear(), date.getMonth(), 1).getDate();
                // this.params.to = new Date(date.getFullYear(), date.getMonth() + 1, 0).toString('mm/dd/yyyy');
                this.params.from = this.formattedDate(0);
                this.params.to = this.formattedDate(1);
                await this.getTrainingAssistants()
                await this.getTrainingEndorsementData(this.params);

            },

            formattedDate(first) {
                let today = new Date();
                let date = new Date(today.getFullYear(), today.getMonth() + first, 1 - first);
                let month = date.getMonth() + 1;
                month = (month < 10) ? '0' + month : month;
                let day = date.getDate();
                day = (day < 10) ? '0' + day : day;
                return `${date.getFullYear()}-${month}-${day}`;
            },

            switchTab(courseId) {
                document.getElementById('list' + courseId).click();
            }
        },

        computed: {
            ...mapGetters([ 'trainingEndorsementData','trainingAssistants' ])
        },

        created() {
            this.initializeData();
        }

    }
</script>

<style scoped>

</style>
